module.exports = __webpack_public_path__ + "static/media/crazyDomain.faf7e2b5.webp";